module.exports = __webpack_public_path__ + "img/loan-savings.cbd0cea1.png";